function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1638",
  "data-name": "Group 1638",
  transform: "translate(-495.526 -363.019)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_274",
  "data-name": "Path 274",
  d: "M0,1V14.059a1,1,0,0,0,1,1H15.815a1,1,0,0,0,.72-.306l5.911-6.126a1,1,0,0,0,.039-1.345L16.539.349A1,1,0,0,0,15.78,0H1A1,1,0,0,0,0,1Z",
  transform: "translate(496.763 380.386) rotate(-45)",
  fill: "none",
  stroke: "#25a4b4",
  strokeWidth: 1.75
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(512.5 372.5)",
  fill: "#25a4b4"
}));

var SvgIconTag = function SvgIconTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.253,
    height: 29.253,
    viewBox: "0 0 29.253 29.253",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-tag.532917ad.svg";
export { ForwardRef as ReactComponent };